if ($('#app-form-tv-comscore-add-ranker-station').length) {

  /*  form_validator('#app-form-tv-ranker-station',
        {
            form_market: {
                required: true
            },
            form_references: {
                required: true,
            },
            form_dayparts: {
                required: true,
            },
            form_stations: {
                required: true,
            },

        },
        {
            form_market: "Please select a Market.",
            form_references: "Please select at least one Reference Book.",
            form_dayparts: "Please select at least one Daypart.",

            form_stations: "Please select at least one Station.",
        }
    );*/


    var demo_all = [];
    $('#dayparts').multiSelect($.extend({}, {selectableOptgroup: true}, searchableMultiSelectDef));
    $('#projection').datepicker({minViewMode: 'months', format: 'MM yyyy'});
    $('#stations').multiSelect(searchableMultiSelectDef);


    var form_markets;
    var form_books;
    var form_curr_market;
    var form_curr_hut;
    var form_curr_share;
    var form_curr_references;
    var form_curr_stations;
    var form_curr_dayparts;



    $(document).ready(function() {
        $(document).on('click', '#select_all_sta', function () {
            var selected = []
            $('#form_stations option:selected').each(function () {
                selected.push($(this).val())
            })
            $('#form_stations option').each(function () {
                if (selected.length <= 15 && selected.indexOf($(this).val()) === -1) {
                    $(this).prop('select', true)
                    $('#form_stations').multiSelect('select', [$(this).val()]);
                    selected.push($(this).val())
                }
            })
        });

        $(document).on('click', '#deselect_all', function () {
            $('#form_stations').multiSelect('deselect_all');
        });
        demos = collect(demos);
        show_loader();
        $.ajax({
            type: "GET",
            url: '/ratings/comscore/tv/local/additional-markets',
            dataType: 'json',
            success: function (data) {
                var input = $('#form_market');
                data = collect(data).sortBy('name')/*.keyBy('dma')*/.all();
                console.log("markets");
                console.log(data);
                input.append('<option value=""></option>');
                $.each(data, function (index, value) {
                    if (editing == true) {
                        var se = '';
                        if (edit['market'] === value['dma'])
                            se = 'selected';
                        var aux = se !== '' ? 'selected' : '';
                        input.append('<option  ' + aux + ' value="' + value['dma'] + '">' + value['name'] + '</option>');
                    } else
                        input.append('<option value="' + value['dma'] + '">' + value['name'] + '</option>');
                });
                data = collect(data).sortBy('name').keyBy('dma').all();

                form_markets = data;


                input.select2({
                    placeholder: "Select one...",
                    minimumResultsForSearch: 10
                }).on('select2:select', function (evt) {
                    tvRankerOnMarketChange();
                    // tvRankerFormReset(1);
                });
                if (editing == true)
                    tvRankerOnMarketChange(true)

                $(".select2-selection.select2-selection--multiple:not(:has(i.fa.fa-search.search-icon-input))").prepend("<i class='fa fa-search search-icon-input'></i>")

                $('#form_playback_type').select2({
                    placeholder: "Choose a Market..",
                    minimumResultsForSearch: 10
                });

                $('#form_share').select2({
                    placeholder: "Choose a Data Stream..",
                    minimumResultsForSearch: 10,
                    'allowClear': true
                });

                $('#form_hut').select2({
                    placeholder: "Choose a Data Stream..",
                    minimumResultsForSearch: 10,
                    'allowClear': true
                });
                $(".select2-selection.select2-selection--multiple:not(:has(i.fa.fa-search.search-icon-input))").prepend("<i class='fa fa-search search-icon-input'></i>")

                $('#form_dayparts').multiSelect({
                    selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
                    selectionHeader: "<div style='height: 38px;'><label>Selected</label></div>",
                    afterInit: function (ms) {
                        var that = this,
                            $selectableSearch = that.$selectableUl.prev(),
                            selectableSearchString = '#' + that.$container.attr('id') + ' .ms-elem-selectable:not(.ms-selected)';

                        that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                            .on('keydown', function (e) {
                                if (e.which === 40) {
                                    that.$selectableUl.focus();
                                    return false;
                                }
                            });
                    },
                    afterSelect: function (values) {
                        this.qs1.cache();

                        form_curr_dayparts = this.$element.val();
                        if (this.$element.val().length <= 5) {
                            //tvRankerValidate();
                        } else {
                            this.$element.multiSelect('deselect', values);
                            form_curr_dayparts = this.$element.val();

                            swal({
                                    title: "Warning",
                                    text: "The max number is 5 ...",
                                    type: "warning",
                                    showCancelButton: true,
                                    confirmButtonClass: "btn-danger",
                                    confirmButtonText: "OK",
                                    cancelButtonText: "Close",
                                    closeOnConfirm: true,
                                    closeOnCancel: true
                                },
                                function (isConfirm) {

                                });
                        }

                        if (form_curr_dayparts.length < 5) {
                            this.$element.closest('.form_dayparts_container').find('.select-count').html('(' + form_curr_dayparts.length + ' / 5)').removeClass('text-warning').addClass('text-muted');
                        } else {
                            this.$element.closest('.form_dayparts_container').find('.select-count').html('(' + form_curr_dayparts.length + ' / 5)').removeClass('text-muted').addClass('text-warning');
                        }
                    },
                    afterDeselect: function (values) {
                        this.qs1.cache();

                        form_curr_dayparts = this.$element.val();
                        //tvRankerValidate();

                        this.$element.closest('.form_dayparts_container').find('.select-count').html('(' + form_curr_dayparts.length + ' / 5)').removeClass('text-warning').addClass('text-muted');
                    }
                });

                $('#form_projection').datepicker(
                    {
                        minViewMode: 'months',
                        format: 'MM yyyy',
                        orientation: 'bottom'
                    }).on('changeDate', function () {
                    //tvRankerValidate();
                });

                //$('#form_stations').multiSelect(searchableMultiSelectDef);
                $('#form_stations').multiSelect({
                    selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
                    selectionHeader: "<div style='height: 38px;'><input type='button' class='btn btn-primary m-r-5 btn-sm ' value='Select All' id='select_all_sta' >&nbsp;<input type='button' class='btn btn-primary m-r-5 btn-sm ' value='Deselect All' id='deselect_all'>" +
                        "</div>",
                    selectAllText: 'Select All',
                    deselectAllText: 'Deselect All',
                    afterInit: function (ms) {
                        var that = this,
                            $selectableSearch = that.$selectableUl.prev(),
                            selectableSearchString = '#' + that.$container.attr('id') + ' .ms-elem-selectable:not(.ms-selected)';

                        that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                            .on('keydown', function (e) {
                                if (e.which === 40) {
                                    that.$selectableUl.focus();
                                    return false;
                                }
                            });
                    },
                    afterSelect: function (values) {
                        this.qs1.cache();

                        form_curr_stations = this.$element.val();
                        if (this.$element.val().length <= 15) {
                            //tvRankerValidate();
                        } else {
                            this.$element.multiSelect('deselect', values);
                            form_curr_stations = this.$element.val();

                            swal({
                                    title: "Warning",
                                    text: "The max number is 15 ...",
                                    type: "warning",
                                    showCancelButton: true,
                                    confirmButtonClass: "btn-danger",
                                    confirmButtonText: "OK",
                                    cancelButtonText: "Close",
                                    closeOnConfirm: true,
                                    closeOnCancel: true
                                },
                                function (isConfirm) {

                                });
                        }

                        if (form_curr_stations.length < 15) {
                            this.$element.closest('.form_dists_container').find('.select-count').html('(' + form_curr_stations.length + ' / 15)').removeClass('text-warning').addClass('text-muted');
                        } else {
                            this.$element.closest('.form_dists_container').find('.select-count').html('(' + form_curr_stations.length + ' / 15)').removeClass('text-muted').addClass('text-warning');
                        }
                    },
                    afterDeselect: function (values) {
                        this.qs1.cache();

                        form_curr_stations = this.$element.val();
                        //tvRankerValidate();

                        this.$element.closest('.form_dists_container').find('.select-count').html('(' + form_curr_stations.length + ' / 15)').removeClass('text-warning').addClass('text-muted');
                    }
                });
                input = $('#form_references');
                multiSelectReference(input)

                // input.multiSelect({
                //     selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
                //     selectionHeader: "<div style='height: 38px;'><label>Selected</label></div>",
                //     afterInit: function(ms){
                //         var that = this,
                //             $selectableSearch = that.$selectableUl.prev(),
                //             selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';
                //
                //         that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                //             .on('keydown', function(e){
                //                 if (e.which === 40){
                //                     that.$selectableUl.focus();
                //                     return false;
                //                 }
                //             });
                //     },
                //     afterSelect: function(values){
                //         this.qs1.cache();
                //
                //         form_curr_references = this.$element.val();
                //         if(this.$element.val().length <= 4){
                //             // if ($("#top_x").is(':checked'))
                //             //     tvRankerOnBooksChange(false, 1);
                //             // else
                //             //     tvRankerOnBooksChange(false, 0);
                //         }else{
                //             this.$element.multiSelect('deselect', values);
                //             form_curr_references = this.$element.val();
                //
                //             swal({
                //                     title: "Warning",
                //                     text: "The max number is 4 ...",
                //                     type: "warning",
                //                     showCancelButton: true,
                //                     confirmButtonClass: "btn-danger",
                //                     confirmButtonText: "OK",
                //                     cancelButtonText: "Close",
                //                     closeOnConfirm: true,
                //                     closeOnCancel: true
                //                 },
                //                 function (isConfirm) {
                //
                //                 });
                //         }
                //
                //         if(form_curr_references.length < 4){
                //             this.$element.closest('.form_references_container').find('.select-count').html('(' + form_curr_references.length + ' / 4)').removeClass('text-warning').addClass('text-muted');
                //         }else{
                //             this.$element.closest('.form_references_container').find('.select-count').html('(' + form_curr_references.length + ' / 4)').removeClass('text-muted').addClass('text-warning');
                //         }
                //     },
                //     afterDeselect: function(values){
                //         this.qs1.cache();
                //         this.$element.closest('.form_references_container').find('.select-count').html('(' + form_curr_references.length + ' / 4)').removeClass('text-warning').addClass('text-muted');
                //     }
                // });

                $('#form_reset').bind('click', function () {
                    tvRankerFormReset();
                });

                // if(editing == true && pepe=== true){
                //     form_curr_market = form_markets[$('#form_market').val()];
                //     if(edit['primary_demo_type']=='m') {
                //         $('#primary_demo_type_m').prop('checked', true);
                //         $('.demo_name').val(edit['primary_demo_name']);
                //         r=1;
                //         $('#primary_demo_type_m').trigger("change");
                //
                //     }
                //     if(edit['primary_demo_type']=='f'){
                //         $('#primary_demo_type_f').prop('checked', true);
                //         $('.demo_name').val(edit['primary_demo_name']);
                //         r=1;
                //         $('#primary_demo_type_f').trigger("change");
                //
                //     }
                //     if(edit['primary_demo_type']=='p') {
                //         $('#primary_demo_type_p').prop('checked', true);
                //         $('.demo_name').val(edit['primary_demo_name']);
                //         r=1;
                //         $('#primary_demo_type_p').trigger("change");
                //
                //
                //     }
                //     if(edit['primary_demo_type']=='hh') {
                //         $('#primary_demo_type_hh').prop('checked', true);
                //         $('.demo_name').val(edit['primary_demo_name']);
                //         r=1;
                //         $('#primary_demo_type_hh').trigger("change");
                //
                //
                //     }
                //
                //     if(edit['secondary_demo_type']=='m') {
                //
                //         $('#secondary_demo_type_m').prop('checked', true);
                //         $('.demo_name').val(edit['secondary_demo_name']);
                //         r=2;
                //         $('#secondary_demo_type_m').trigger("change");
                //
                //     }
                //     if(edit['secondary_demo_type']=='f'){
                //         $('#secondary_demo_type_f').prop('checked', true);
                //         $('.demo_name').val(edit['secondary_demo_name']);
                //         r=2;
                //         $('#secondary_demo_type_f').trigger("change");
                //
                //     }
                //     if(edit['secondary_demo_type']=='p') {
                //         $('#secondary_demo_type_p').prop('checked', true);
                //         $('.demo_name').val(edit['secondary_demo_name']);
                //         r=2;
                //         $('#secondary_demo_type_p').trigger("change");
                //
                //
                //     }
                //     if(edit['secondary_demo_type']=='hh') {
                //         $('#secondary_demo_type_hh').prop('checked', true);
                //         $('.demo_name').val(edit['secondary_demo_name']);
                //         r=2;
                //         $('#secondary_demo_type_hh').trigger("change");
                //
                //
                //     }
                //     tvRankerOnMarketChange();
                //
                // }

                hide_loader();
            },
            error: function (xhr) {
                ajax_error();
                debug(xhr.responseText);
                hide_loader();
            }
        });

        /*$.ajax({
            type: "GET",
            url: '/ratings/comscore/metadata/demographics ',
            dataType: 'json',
            success: function (data) {
                console.log(data);
                console.log("THIS IS THE EDIT VAR: ", edit)
                var html = '';
                demo_all= data['result_rows'];
                demo_all.sort(function(a,b){
                    var au = a[2];
                    var bu = b[2];
                    return au.localeCompare(bu);
                });
                var income_demos = []; var ethnic_demos = []; var education_demos = []; var historic_demos = []; var owner_demos = []; var automotive_demos = [];
                if(editing === true) {
                    var demo1 = $('input:radio[name=primary_demo_type]:checked').val();
                    var demo2 = $('input:radio[name=secondary_demo_type]:checked').val();
                    var html1 = '';
                    var html2 = ''
                    var html_income = '<option value=""> - Select - </option>';
                    var html_ethnic = '<option value=""> - Select - </option>';
                    var html_education = '<option value=""> - Select - </option>';
                    var html_owner = '<option value=""> - Select - </option>';
                    var html_historic = '<option value=""> - Select - </option>';
                    var html_automotive = '<option value=""> - Select - </option>';
                    $.each(demo_all, function (index, value) {
                        var selected_income = (typeof edit.income_demo_ids !== 'undefined' && value[0] == edit.income_demo_ids) ? "selected" : "";
                        var selected_ethnic = (typeof edit.ethnic_demo_ids !== 'undefined' && value[0] == edit.ethnic_demo_ids) ? "selected" : "";
                        var selected_education = (typeof edit.education_demo_ids !== 'undefined' && value[0] == edit.education_demo_ids) ? "selected" : "";
                        var selected_historic = (typeof edit.historic_demo_ids !== 'undefined' && value[0] == edit.historic_demo_ids) ? "selected" : "";
                        var selected_owner = (typeof edit.owner_demo_ids !== 'undefined' && value[0] == edit.owner_demo_ids) ? "selected" : "";
                        var selected_automotive = (typeof edit.automotive_demo_ids !== 'undefined' && value[0] == edit.automotive_demo_ids) ? "selected" : "";
                        if(value[12].indexOf('Race/Ethnicity') !== -1){
                            ethnic_demos.push(value);
                            html_ethnic += '<option title="'+ value[2] +'" value="' + value[0] + '" ' + selected_ethnic + '>' + value[2] + '</option>';
                        }
                        if(value[12].indexOf('Household Income') !== -1){
                            income_demos.push(value);
                            html_income += '<option title="'+ value[2] +'" value="' + value[0] + '" ' + selected_income + '>' + value[2] + '</option>';
                        }
                        if(value[12].indexOf('Education') !== -1){
                            education_demos.push(value);
                            html_education += '<option title="'+ value[2] +'" value="' + value[0] + '" ' + selected_education + '>' + value[2] + '</option>';
                        }
                        if(value[12].indexOf('Residence Ownership') !== -1){
                            owner_demos.push(value);
                            html_owner += '<option title="'+ value[2] +'" value="' + value[0] + '" ' + selected_owner + '>' + value[2] + '</option>';
                        }
                        if(value[12].indexOf('Historic') !== -1){
                            historic_demos.push(value);
                            html_historic += '<option title="'+ value[2] +'" value="' + value[0] + '" ' + selected_historic + '>' + value[2] + '</option>';
                        }
                        if(value[15].indexOf('Automotive') !== -1){
                            if(typeof comscore_autom_demos !== 'undefined' && comscore_autom_demos.includes(value[12])) {
                                automotive_demos.push(value);
                                console.log("Automotive: ", value[12])
                                html_automotive += '<option title="' + value[2] + '" value="' + value[0] + '" ' + selected_automotive + '>' + value[2] + ' (' + value[12] + ')' + '</option>';
                            }
                        }
                        var selected1 = (value[0] == edit.primary_demo_ids) ? "selected" : ""
                        var selected2 = (value[0] == edit.secondary_demo_ids) ? "selected" : ""
                        if(value[12].indexOf('Age Range') !== -1){
                            if(demo1 === 'p') {
                                if (value[2].indexOf('A') !== -1) {
                                    var ts= value[2].replace('A', "P ");
                                    html1 += '<option title="'+ ts +'" value="' + value[0] + '" ' + selected1 + '>' + ts + '</option>';
                                }
                            }
                            if(demo2 === 'p') {
                                if (value[2].indexOf('A') !== -1) {
                                    var ts= value[2].replace('A', "P ");
                                    html2 += '<option title="'+ ts +'" value="' + value[0] + '" ' + selected2 + '>' + ts + '</option>';
                                }
                            }

                            if(demo1 === 'm') {
                                if (value[2].indexOf('M') !== -1) {
                                    var ts= value[2].replace('M', "M ");
                                    html1 += '<option title="'+ ts +'" value="' + value[0] + '" ' + selected1 + '>' + ts + '</option>';
                                }
                            }
                            if(demo2 === 'm') {
                                if (value[2].indexOf('M') !== -1) {
                                    var ts= value[2].replace('M', "M ");
                                    html2 += '<option title="'+ ts +'" value="' + value[0] + '" ' + selected2 + '>' + ts + '</option>';
                                }
                            }

                            if(demo1 === 'f') {
                                if (value[2].indexOf('W') !== -1) {
                                    var ts= value[2].replace('W', "F ");
                                    html1 += '<option title="'+ ts +'" value="' + value[0] + '"  ' + selected1 + '>' + ts + '</option>';
                                }
                            }
                            if(demo2 === 'f') {
                                if (value[2].indexOf('W') !== -1) {
                                    var ts= value[2].replace('W', "F ");
                                    html2 += '<option title="'+ ts +'" value="' + value[0] + '" ' + selected2 + '>' + ts + '</option>';
                                }
                            }
                        }
                        if(value[12].indexOf('Household Composition') !== -1 && value[2].indexOf("A25") === -1 && value[2].indexOf("A35") === -1){
                            if(demo1 === 'hh') {
                                if(html1 == "") {
                                    var this_selected = ("all" == edit.primary_demo_ids) ? "selected" : ""
                                    html1 += '<option value="all" ' + this_selected + '>---</option>';
                                }
                                html1 += '<option title="'+ value[2] +'" value="' + value[0] + '" ' + selected1 + '>' + value[2] + '</option>';
                            }
                        }
                        if(value[12].indexOf('Household Composition') !== -1 && value[2].indexOf("A25") === -1 && value[2].indexOf("A35") === -1){
                            if(demo2 === 'hh') {
                                if(html2 == "") {
                                    var this_selected = ("all" == edit.primary_demo_ids) ? "selected" : ""
                                    html2 += '<option value="all" ' + this_selected + '>---</option>';
                                }
                                html2 += '<option title="'+ value[2] +'" value="' + value[0] + '" ' + selected2 + '>' + value[2] + '</option>';
                            }
                        }
                    });
                    $("#primary_demo_ids").html(html1);
                    $("#secondary_demo_ids").html(html2);
                    $("#income_demo_ids").html(html_income);
                    $('#income_demo_ids').select2({
                        minimumResultsForSearch: 2,
                        'allowClear': false
                    }).bind('select2:select', function () {
                        $(this).closest('.tv-select-demo-container').find('.demo_name')
                            .val($(this).find('option[value="' + $(this).val() + '"]').html());
                    });
                    $("#historic_demo_ids").html(html_historic);
                    $('#historic_demo_ids').select2({
                        minimumResultsForSearch: 2,
                        'allowClear': false
                    }).bind('select2:select', function () {
                        $(this).closest('.tv-select-demo-container').find('.demo_name')
                            .val($(this).find('option[value="' + $(this).val() + '"]').html());
                    });
                    $("#education_demo_ids").html(html_education);
                    $('#education_demo_ids').select2({
                        minimumResultsForSearch: 2,
                        'allowClear': false
                    }).bind('select2:select', function () {
                        $(this).closest('.tv-select-demo-container').find('.demo_name')
                            .val($(this).find('option[value="' + $(this).val() + '"]').html());
                    });
                    $("#owner_demo_ids").html(html_owner);
                    $('#owner_demo_ids').select2({
                        minimumResultsForSearch: 2,
                        'allowClear': false
                    }).bind('select2:select', function () {
                        $(this).closest('.tv-select-demo-container').find('.demo_name')
                            .val($(this).find('option[value="' + $(this).val() + '"]').html());
                    });
                    $("#ethnic_demo_ids").html(html_ethnic);
                    $('#ethnic_demo_ids').select2({
                        minimumResultsForSearch: 2,
                        'allowClear': false
                    }).bind('select2:select', function () {
                        $(this).closest('.tv-select-demo-container').find('.demo_name')
                            .val($(this).find('option[value="' + $(this).val() + '"]').html());
                    });
                    $("#automotive_demo_ids").html(html_automotive);
                    $('#automotive_demo_ids').select2({
                        minimumResultsForSearch: 2,
                        'allowClear': false
                    }).bind('select2:select', function () {
                        $(this).closest('.tv-select-demo-container').find('.demo_name')
                            .val($(this).find('option[value="' + $(this).val() + '"]').html());
                    });
                    $('#primary_demo_ids').select2({
                        minimumResultsForSearch: 10,
                        'allowClear': false
                    }).bind('select2:select', function () {
                        $(this).closest('.tv-select-demo-container').find('.demo_name')
                            .val($(this).find('option[value="' + $(this).val() + '"]').html());
                    });
                    $('#secondary_demo_ids').select2({
                        minimumResultsForSearch: 10,
                        'allowClear': false
                    }).bind('select2:select', function () {
                        $(this).closest('.tv-select-demo-container').find('.demo_name')
                            .val($(this).find('option[value="' + $(this).val() + '"]').html());
                    });

                    $('#demo_groups').select2({
                        minimumResultsForSearch: 2,
                        'allowClear': false
                    }).bind('select2:select', function () {

                    });
                    $('#all_demo_ids').multiSelect({
                        selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
                        selectionHeader: "<div style='height: 38px;'><label>Selected</label></div>",
                        afterInit: function(ms){
                            var that = this,
                                $selectableSearch = that.$selectableUl.prev(),
                                selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

                            that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                                .on('keydown', function(e){
                                    if (e.which === 40){
                                        that.$selectableUl.focus();
                                        return false;
                                    }
                                });
                        },
                        afterSelect: function(values){
                            this.qs1.cache();

                        },
                        afterDeselect: function(values){
                        }
                    });

                }else{
                    var html_income = '<option value=""> - Select - </option>';
                    var html_ethnic = '<option value=""> - Select - </option>';
                    var html_education = '<option value=""> - Select - </option>';
                    var html_owner = '<option value=""> - Select - </option>';
                    var html_historic = '<option value=""> - Select - </option>';
                    var html_automotive = '<option value=""> - Select - </option>';
                    var demo= $('input:radio[name=primary_demo_type]:checked').val();
                    $('input[name="secondary_demo_name"]').val("");
                    $.each(data['result_rows'], function (index, value) {
                        if(value[12].indexOf('Race/Ethnicity') !== -1){
                            ethnic_demos.push(value);
                            html_ethnic += '<option title="'+ value[2] +'" value="' + value[0] + '" >' + value[2] + '</option>';
                            if($('input[name="ethnic_demo_name"]').val() === "")
                                $('input[name="ethnic_demo_name"]').val(value[2]);
                        }
                        if(value[12].indexOf('Household Income') !== -1){
                            income_demos.push(value);
                            html_income += '<option title="'+ value[2] +'" value="' + value[0] + '" >' + value[2] + '</option>';
                            if($('input[name="income_demo_name"]').val() === "")
                                $('input[name="income_demo_name"]').val(value[2]);
                        }
                        if(value[12].indexOf('Education') !== -1){
                            education_demos.push(value);
                            html_education += '<option title="'+ value[2] +'" value="' + value[0] + '" >' + value[2] + '</option>';
                            if($('input[name="education_demo_name"]').val() === "")
                                $('input[name="education_demo_name"]').val(value[2]);
                        }
                        if(value[12].indexOf('Residence Ownership') !== -1){
                            owner_demos.push(value);
                            html_owner += '<option title="'+ value[2] +'" value="' + value[0] + '" >' + value[2] + '</option>';
                            if($('input[name="owner_demo_name"]').val() === "")
                                $('input[name="owner_demo_name"]').val(value[2]);
                        }
                        if(value[12].indexOf('Historic') !== -1){
                            historic_demos.push(value);
                            html_historic += '<option title="'+ value[2] +'" value="' + value[0] + '" >' + value[2] + '</option>';
                            if($('input[name="historic_demo_name"]').val() === "")
                                $('input[name="historic_demo_name"]').val(value[2]);
                        }
                        if(value[15].indexOf('Automotive') !== -1){
                            if(typeof comscore_autom_demos !== 'undefined' && comscore_autom_demos.includes(value[12])) {
                                console.log('Automotive: ', value[12])
                                automotive_demos.push(value);
                                html_automotive += '<option title="' + value[2] + '" value="' + value[0] + '" >' + value[2] + ' (' + value[12] + ')' + '</option>';
                                if ($('input[name="automotive_demo_name"]').val() === "")
                                    $('input[name="automotive_demo_name"]').val(value[2]);
                            }
                        }
                        if(value[12].indexOf('Age Range') !== -1){
                            if(demo== 'p') {
                                if (value[2].indexOf('A') !== -1) {
                                    var ts= value[2].replace('A', "P ");
                                    html += '<option title="'+ ts +'" value="' + value[0] + '">' + ts + '</option>';
                                    if($('input[name="primary_demo_name"]').val() === "")
                                        $('input[name="primary_demo_name"]').val(ts);
                                }
                            }
                            if(demo== 'm') {
                                if (value[2].indexOf('M') !== -1) {
                                    var ts= value[2].replace('M', "M ");
                                    html += '<option title="'+ ts +'" value="' + value[0] + '">' + ts + '</option>';
                                    if($('input[name="primary_demo_name"]').val() === "")
                                        $('input[name="primary_demo_name"]').val(ts);
                                }
                            }
                            if(demo== 'f') {
                                if (value[2].indexOf('W') !== -1) {
                                    var ts= value[2].replace('W', "F ");
                                    html += '<option title="'+ ts +'" value="' + value[0] + '">' + ts + '</option>';
                                    if($('input[name="primary_demo_name"]').val() === "")
                                        $('input[name="primary_demo_name"]').val(ts);
                                }
                            }
                        }
                        if(value[12].indexOf('Household Composition') !== -1){
                            if(demo == 'hh') {
                                if(html == "") {
                                    html += '<option value="all">---</option>';
                                }
                                html += '<option title="'+ value[2] +'" value="' + value[0] + '">' + value[2] + '</option>';
                                if($('input[name="primary_demo_name"]').val() === "")
                                    $('input[name="primary_demo_name"]').val("---");
                            }
                        }

                    });

                    $("#income_demo_ids").html(html_income);
                    $('#income_demo_ids').select2({
                        minimumResultsForSearch: 2,
                        'allowClear': false
                    });
                    $("#historic_demo_ids").html(html_historic);
                    $('#historic_demo_ids').select2({
                        minimumResultsForSearch: 2,
                        'allowClear': false
                    });
                    $("#education_demo_ids").html(html_education);
                    $('#education_demo_ids').select2({
                        minimumResultsForSearch: 2,
                        'allowClear': false
                    });
                    $("#owner_demo_ids").html(html_owner);
                    $('#owner_demo_ids').select2({
                        minimumResultsForSearch: 2,
                        'allowClear': false
                    });
                    $("#ethnic_demo_ids").html(html_ethnic);
                    $('#ethnic_demo_ids').select2({
                        minimumResultsForSearch: 2,
                        'allowClear': false
                    });
                    $("#automotive_demo_ids").html(html_automotive);
                    $('#automotive_demo_ids').select2({
                        minimumResultsForSearch: 2,
                        'allowClear': false
                    });
                    $('#primary_demo_ids').select2({
                        minimumResultsForSearch: 10,
                        'allowClear': false
                    });

                    $("#primary_demo_ids").html(html);
                    $('#primary_demo_ids').select2({
                        minimumResultsForSearch: 10,
                        'allowClear': false
                    });
                    $('#secondary_demo_ids').select2({
                        minimumResultsForSearch: 10,
                        'allowClear': false
                    });

                    $('#demo_groups').select2({
                        minimumResultsForSearch: 2,
                        'allowClear': false
                    }).bind('select2:select', function () {

                    });
                    $('#all_demo_ids').multiSelect({
                        selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
                        selectionHeader: "<div style='height: 38px;'><label>Selected</label></div>",
                        afterInit: function(ms){
                            var that = this,
                                $selectableSearch = that.$selectableUl.prev(),
                                selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

                            that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                                .on('keydown', function(e){
                                    if (e.which === 40){
                                        that.$selectableUl.focus();
                                        return false;
                                    }
                                });
                        },
                        afterSelect: function(values){
                            this.qs1.cache();

                        },
                        afterDeselect: function(values){
                        }
                    });
                }
                console.log('income', income_demos);
                console.log('ethnic', ethnic_demos);
                console.log('education_demos', education_demos);
                console.log('historic_demos', historic_demos);
                console.log('owner_demos', owner_demos);
                console.log('owner_demos', automotive_demos);
            },
            error: function (err) {
                console.log(err);
                hide_loader();
                debug(err.responseText);

            }
        });*/

        $('#demo_groups').select2({
            minimumResultsForSearch: 2,
            'allowClear': false
        }).bind('select2:select', function (e) {
            console.log('select', $(this).val());
            var pos = e.params.data.id;
            show_loader();
            $.ajax({
                type: "GET",
                url: '/ratings/comscore/metadata/demographics ',
                dataType: 'json',
                success: function (data) {
                    var html = '';
                    console.log('pos', pos);
                    for(var i in data['result_rows']){
                        if((typeof data['result_rows'][i][12] !== 'undefined' && data['result_rows'][i][12] !== null && data['result_rows'][i][12].indexOf(pos) !== -1) || (typeof data['result_rows'][i][15] !== 'undefined' && data['result_rows'][i][15] !== null && data['result_rows'][i][15].indexOf(pos) !== -1)) {
                            if(pos === "Automotive") {
                                if(comscore_autom_demos.indexOf(data['result_rows'][i][12]) !== -1)
                                    html += '<option class="' + pos + '" value="' + data['result_rows'][i][0] + '">(' + data['result_rows'][i][12] + ') ' + data['result_rows'][i][2].toUpperCase() + '</option>';
                            }else
                                html += '<option class="' + pos + '" value="' + data['result_rows'][i][0] + '">('+ pos +') ' + data['result_rows'][i][2].toUpperCase() + '</option>';
                        }
                    }
                    console.log('html', html);
                    $("#all_demo_ids").append(html).multiSelect("refresh");
                    hide_loader();
                },
                error: function(xhr){
                    hide_loader();
                }
            });
        }).bind('select2:unselect', function (e) {
            show_loader();
            var data = e.params.data;
            console.log('unselect', data);
            $("." + data.id).each(function(){
               $(this).remove();
            });
            hide_loader();
            $("#all_demo_ids").multiSelect("refresh");
        });
        if(editing === false) {
            $('#all_demo_ids').multiSelect({
                selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
                selectionHeader: "<div style='height: 38px;'><label>Selected</label></div>",
                afterInit: function (ms) {
                    var that = this,
                        $selectableSearch = that.$selectableUl.prev(),
                        selectableSearchString = '#' + that.$container.attr('id') + ' .ms-elem-selectable:not(.ms-selected)';

                    that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                        .on('keydown', function (e) {
                            if (e.which === 40) {
                                that.$selectableUl.focus();
                                return false;
                            }
                        });
                },
                afterSelect: function (values) {
                    this.qs1.cache();
                    var names = [];
                    $('#all_demo_ids option:selected').each(function () {
                        names.push($(this).text());
                    });
                    console.log('names', names);
                    $('#all_demo_name').val(JSON.stringify(names));
                },
                afterDeselect: function (values) {
                    var names = [];
                    $('#all_demo_ids option:selected').each(function () {
                        names.push($(this).text());
                    });
                    console.log('names', names);
                    $('#all_demo_name').val(JSON.stringify(names));
                }
            });
        }else{
            show_loader();
            $.ajax({
                type: "GET",
                url: '/ratings/comscore/metadata/demographics ',
                dataType: 'json',
                success: function (data) {
                    var html = '';
                    //console.log('pos', pos);
                    for(var j in demo_groups) {
                        var pos = demo_groups[j];
                        for (var i in data['result_rows']) {
                            if (data['result_rows'][i][12].indexOf(pos) !== -1 || data['result_rows'][i][15].indexOf(pos) !== -1) {
                                if (pos === "Automotive") {
                                    if (comscore_autom_demos.indexOf(data['result_rows'][i][12]) !== -1)
                                        html += '<option ' + ((demo_selected.indexOf(data['result_rows'][i][0]) !== -1) ? 'selected' : '') + ' class="' + pos + '" value="' + data['result_rows'][i][0] + '">(' + data['result_rows'][i][12] + ') ' + data['result_rows'][i][2].toUpperCase() + '</option>';
                                } else
                                    html += '<option ' + ((demo_selected.indexOf(data['result_rows'][i][0]) !== -1) ? 'selected' : '') + ' class="' + pos + '" value="' + data['result_rows'][i][0] + '">(' + pos + ') ' + data['result_rows'][i][2].toUpperCase() + '</option>';
                            }
                        }
                    }
                    console.log('html', html);
                    $("#all_demo_ids").append(html);
                    $('#all_demo_ids').multiSelect({
                        selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
                        selectionHeader: "<div style='height: 38px;'><label>Selected</label></div>",
                        afterInit: function (ms) {
                            var that = this,
                                $selectableSearch = that.$selectableUl.prev(),
                                selectableSearchString = '#' + that.$container.attr('id') + ' .ms-elem-selectable:not(.ms-selected)';

                            that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                                .on('keydown', function (e) {
                                    if (e.which === 40) {
                                        that.$selectableUl.focus();
                                        return false;
                                    }
                                });
                        },
                        afterSelect: function (values) {
                            this.qs1.cache();
                            var names = [];
                            $('#all_demo_ids option:selected').each(function () {
                                names.push($(this).text());
                            });
                            console.log('names', names);
                            $('#all_demo_name').val(JSON.stringify(names));
                        },
                        afterDeselect: function (values) {
                            var names = [];
                            $('#all_demo_ids option:selected').each(function () {
                                names.push($(this).text());
                            });
                            console.log('names', names);
                            $('#all_demo_name').val(JSON.stringify(names));
                        }
                    });
                    hide_loader();
                },
                error: function(xhr){
                    hide_loader();
                }
            });
        }
    });

    function multiSelectReference(input){
        input.multiSelect({
            selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
            selectionHeader: "<div style='height: 38px;'><label>Selected</label></div>",
            afterInit: function(ms){
                var that = this,
                    $selectableSearch = that.$selectableUl.prev(),
                    selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

                that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                    .on('keydown', function(e){
                        if (e.which === 40){
                            that.$selectableUl.focus();
                            return false;
                        }
                    });
            },
            afterSelect: function(values){
                this.qs1.cache();

                form_curr_references = this.$element.val();
                if(this.$element.val().length <= 4){
                    // if ($("#top_x").is(':checked'))
                    //     tvRankerOnBooksChange(false, 1);
                    // else
                    //     tvRankerOnBooksChange(false, 0);
                }else{
                    this.$element.multiSelect('deselect', values);
                    form_curr_references = this.$element.val();

                    swal({
                            title: "Warning",
                            text: "The max number is 4 ...",
                            type: "warning",
                            showCancelButton: true,
                            confirmButtonClass: "btn-danger",
                            confirmButtonText: "OK",
                            cancelButtonText: "Close",
                            closeOnConfirm: true,
                            closeOnCancel: true
                        },
                        function (isConfirm) {

                        });
                }

                if(form_curr_references.length < 4){
                    this.$element.closest('.form_references_container').find('.select-count').html('(' + form_curr_references.length + ' / 4)').removeClass('text-warning').addClass('text-muted');
                }else{
                    this.$element.closest('.form_references_container').find('.select-count').html('(' + form_curr_references.length + ' / 4)').removeClass('text-muted').addClass('text-warning');
                }
            },
            afterDeselect: function(values){
                this.qs1.cache();
                this.$element.closest('.form_references_container').find('.select-count').html('(' + form_curr_references.length + ' / 4)').removeClass('text-warning').addClass('text-muted');
            }
        });
    }

    var tvRankerOnMarketChange = function(first = false){
        show_loader();
      //  alert('entre al marketchange ' +pepe );
        var market= $("#form_market option:selected").val();
        $('#form_stations').multiSelect("destroy")
        $('#form_stations').multiSelect({
            selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
            selectionHeader: "<div style='height: 38px;'><input type='button' class='btn btn-primary m-r-5 btn-sm ' value='Select All' id='select_all_sta' >&nbsp;<input type='button' class='btn btn-primary m-r-5 btn-sm ' value='Deselect All' id='deselect_all'>" +
                "</div>",
            selectAllText: 'Select All',
            deselectAllText: 'Deselect All',
            afterInit: function(ms){
                var that = this,
                    $selectableSearch = that.$selectableUl.prev(),
                    selectableSearchString = '#'+that.$container.attr('id')+' .ms-elem-selectable:not(.ms-selected)';

                that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                    .on('keydown', function(e){
                        if (e.which === 40){
                            that.$selectableUl.focus();
                            return false;
                        }
                    });
            },
            afterSelect: function(values){
                this.qs1.cache();

                form_curr_stations = this.$element.val();
                if(this.$element.val().length <= 15){
                    //tvRankerValidate();
                }else{
                    this.$element.multiSelect('deselect', values);
                    form_curr_stations = this.$element.val();

                    swal({
                            title: "Warning",
                            text: "The max number is 15 ...",
                            type: "warning",
                            showCancelButton: true,
                            confirmButtonClass: "btn-danger",
                            confirmButtonText: "OK",
                            cancelButtonText: "Close",
                            closeOnConfirm: true,
                            closeOnCancel: true
                        },
                        function (isConfirm) {

                        });
                }

                if(form_curr_stations.length < 15){
                    this.$element.closest('.form_dists_container').find('.select-count').html('(' + form_curr_stations.length + ' / 15)').removeClass('text-warning').addClass('text-muted');
                }else{
                    this.$element.closest('.form_dists_container').find('.select-count').html('(' + form_curr_stations.length + ' / 15)').removeClass('text-muted').addClass('text-warning');
                }
            },
            afterDeselect: function(values){
                this.qs1.cache();

                form_curr_stations = this.$element.val();
                //tvRankerValidate();

                this.$element.closest('.form_dists_container').find('.select-count').html('(' + form_curr_stations.length + ' / 15)').removeClass('text-warning').addClass('text-muted');
            }
        });
        show_loader();
        var htmltoaddshare = ""
        var htmltoaddhut = ""
        var htmltoaddRef = ""
        // var nowTime = (moment(form_markets[market].end) < moment()) ? moment(form_markets[market].end) : moment()
        // var gtrTime = moment(form_markets[market].start)//moment().subtract(1, 'months').subtract(2, 'years')

        var share = ""
        var hut = ""
        var references = []
        if(typeof editing !== "undefined" && editing == true && first){
            share = edit.share
            hut = edit.hut
            references = [edit.reference_1, edit.reference_2, edit.reference_3, edit.reference_4]
        }
        // while(nowTime >= gtrTime){
        //     var selectedShare = (share == nowTime.format("MM/YYYY")) ? "selected" : ""
        //     var selectedHut = (hut == nowTime.format("MM/YYYY")) ? "selected" : ""
        //     var selectedRef = (references.indexOf(nowTime.format("MM/YYYY")+'-Live Only') !== -1) ? "selected" : ""
        //     htmltoaddshare += '<option ' + selectedShare + ' value="' + nowTime.format("MM/YYYY") + '">' + nowTime.format("MM/YYYY") + '</option>';
        //     htmltoaddhut += '<option ' + selectedHut + ' value="' + nowTime.format("MM/YYYY") + '">' + nowTime.format("MM/YYYY") + '</option>';
        //     htmltoaddRef += '<option ' + selectedRef + ' value="' + nowTime.format("MM/YYYY") + '-Live Only">' + nowTime.format("MM/YYYY") + '; Live Only</option>';
        //     nowTime.subtract(1, 'months')
        // }
        console.log('^^^^^^^^^^^^^^^^^^^^^^^^^form_markets', form_markets);
        console.log('^^^^^^^^^^^^^^^^^^^^^^^^^market only', market);
        $.ajax({
            type: 'GET',
            url: '/campaign/get/comscore/books/allowed/'+ market,
            dataType: 'json',
            encode: true,
            success: function (data) {
                console.log('allowed4: ' + data);
                data.sort(function (a, b) {               // Detach from select, then Sort
                    var at = moment(a);
                    var bt = moment(b);
                    return (at < bt) ? 1 : ((at > bt) ? -1 : 0);
                });
                for (var i in data) {

                    var selectedShare = (share == moment(data[i]).format("MM/YYYY")) ? "selected" : "";
                         var selectedHut = (hut == moment(data[i]).format("MM/YYYY") )? "selected" : "";
                    var selectedRef = (references.indexOf(moment(data[i]).format("MM/YYYY")+'-Live Only') !== -1) ? "selected" : "";
                    htmltoaddshare += '<option ' + selectedShare + ' value="' + moment(data[i]).format("MM/YYYY") + '">' + moment(data[i]).format("MM/YYYY") + '</option>';
                        htmltoaddhut += '<option ' + selectedHut + ' value="' + moment(data[i]).format("MM/YYYY") + '">' + moment(data[i]).format("MM/YYYY") + '</option>';
                        htmltoaddRef += '<option ' + selectedRef + ' value="' + moment(data[i]).format("MM/YYYY") + '-Live Only">' + moment(data[i]).format("MM/YYYY") + '; Live Only</option>';
                }
                $("#form_share").html(htmltoaddshare).select2({placeholder: "Choose a Data Stream..."})
                $("#form_hut").html(htmltoaddhut).select2({placeholder: "Choose a Data Stream..."})
                $("#form_references").html(htmltoaddRef).multiSelect('destroy')

                multiSelectReference($("#form_references"))
            },
            error: function (xhr) {
                hide_loader();
                debug(xhr.responseText);
            }
        });

        if (parseInt(market) !== 0) {
            $.ajax({
                type: "GET",
                url: '/ratings/comscore/stations/' + market,
                dataType: 'json',
                success: function (data) {
                    console.log('stations: ', data);
                    var saved_stations = []
                    if (editing == true) {
                        saved_stations = edit.stations.split(",")
                        edit.stations = "";
                    }
                    data['result_rows'].sort(function compare(a, b) {
                        if (a[1] < b[1]) {
                            return -1;
                        }
                        if (a[1] > b[1]) {
                            return 1;
                        }
                        return 0;
                    })
                    var html = '<optgroup label="Broadcast">';
                    $.each(data['result_rows'], function (index, value) {
                        if (value[5] == market) {
                            console.log('yes: ', value);
                            html += '<option value="' + value[0] + '_st">' + value[1] + ' ('+ value[10] +')</option>';
                        } else {

                        }
                    });
                    html += '</optgroup>'
                    show_loader();
                    $.ajax({
                        type: "GET",
                        url: '/ratings/comscore/networks/ranker' + ((market === 0) ? '?market=' + market : ''),
                        dataType: 'json',
                        success: function (data) {
                            console.log('cable_sations: ', data);
                            html += '<optgroup label="Cable">';
                            html += data
                            html += '</optgroup>'

                            $("#form_stations").html(html);


                            $("#form_stations").multiSelect('refresh');
                            $("#form_stations").multiSelect('select', saved_stations);

                            $('.form_dists_container').removeClass("hidden")
                            $('.help-text.form_stations').hide();

                            //$("#selmarket").val($("#avails_view_market_no option:selected").text());

                            hide_loader();
                        },
                        error: function (err) {
                            hide_loader();
                        }
                    });
                },
                error: function (err) {
                    hide_loader();
                }
            });
        } else {
            $.ajax({
                type: "GET",
                url: '/ratings/comscore/networks/ranker' + ((market === 0) ? '?market='+market : ''),
                dataType: 'json',
                success: function (data) {
                    console.log('cable_sations: ', data);
                    html += '<optgroup label="Cable">';
                    html += data
                    html += '</optgroup>'

                    $("#form_stations").html(html);


                    $("#form_stations").multiSelect('refresh');
                    // $("#form_stations").multiSelect('select', saved_stations);

                    $('.form_dists_container').removeClass("hidden")
                    $('.help-text.form_stations').hide();

                    //$("#selmarket").val($("#avails_view_market_no option:selected").text());

                    hide_loader();
                },
                error: function (err) {
                    hide_loader();
                }
            });
        }
    };

    var tvRankerOnPlaybackChange = function(){
       // alert('entre al playback ' +pepe );
    };


    $('#form_submit').on('click', function (e) {

        var market= $("#form_market option:selected").val();
        var stations= $('#form_stations');

        var daypart= $('#form_dayparts');
        var book= $('#form_references');

        var hut = $('#form_hut');
        var share = $('#form_share');

        hut = hut.val();
        share = share.val();

        var p=false;
        var pp= false;

        if(market !== "")
        {
            if($(book).val().length != 0  || (share !== null && share !== "")|| ( hut !== null  && hut !== "") )
            {
                     if( $(stations).val().length != 0 ) {
                         p = true;
                         pp= true;
                     }
                     else
                         global_notification('warning','Please select at least one Station');
            }
            else
                global_notification('warning','Please select a Book');
        }
        else
            global_notification('warning','Please select a Market');



        if($(daypart).val().length == 0 && p== true)
        {
            pp= false;
            global_notification('warning','Please select at least one Daypart');
        }
        if(pp == true) {

            if (editing == true) {
                $('#saved_report_id').val(general['id']);
                $('#reportable_id').val(edit['id']);
                $('#app-form-tv-comscore-add-ranker-station').attr('action', '/ratings/tv/comscore/additional/ranker/station/editar');
                $('#app-form-tv-comscore-add-ranker-station').submit();
            }

            else
                $('#app-form-tv-comscore-add-ranker-station').submit();
        }

    });

    var checkResetBooks = function(){
        var inputs = {
            'share': $('#form_share'),
            'hut': $('#form_hut'),
            'references': $('#form_references'),
        };
        if(((inputs['share'].val() === '') || (inputs['share'].val() === null)) && ((inputs['hut'].val() === '') || (inputs['hut'].val() === null)) && (inputs['references'].val().length === 0)){
            tvRankerFormReset(2);
        }
    };

    var tvRankerFormReset = function(step){
        if(typeof step === 'undefined'){
            step = 'all';
        }

        if(step === 'all') {
            var input = $('#form_market');

           input.data('select2').destroy();
            input.unbind('select2:select');

            input.html('').append('<option value=""></option>');
            $.each(form_markets, function (index, value) {
                input.append('<option value="' + index + '">' + value['name'] + '</option>')
            });

            input.attr('disabled', null);
            input.select2({
                placeholder: "Select one...",
                minimumResultsForSearch: 10
            }).on('select2:select', function (evt) {
                tvRankerOnMarketChange();
                //tvRankerFormReset(1);
            });
            $(".select2-selection.select2-selection--multiple:not(:has(i.fa.fa-search.search-icon-input))").prepend("<i class='fa fa-search search-icon-input'></i>")

            input = $('#form_playback_type');
            input.select2('val','');

            input = $('#form_dayparts');
            input.multiSelect('deselect_all');
            $('#form_share').val('').trigger("change");
            $('#form_hut').val('').trigger("change");
            $("#form_projection").val("")
            input = $("#form_references")
            input.multiSelect('deselect_all');

            input = $("#form_stations")
            input.empty().multiSelect('refresh')

            input = $('#form_name').val('');
        }

        // if((step < 2) || (step === 'all')) {
        //     input = $('#form_share');
        //
        //     input.data('select2').destroy();
        //     input.unbind('select2:select');
        //     input.html('');
        //     input.attr('disabled', 'disabled');
        //     input.select2({
        //         placeholder: "Select a data stream...",
        //         minimumResultsForSearch: 10
        //     });
        //     $(".select2-selection.select2-selection--multiple:not(:has(i.fa.fa-search.search-icon-input))").prepend("<i class='fa fa-search search-icon-input'></i>")
        //
        //     input = $('#form_hut');
        //
        //     input.data('select2').destroy();
        //     input.unbind('select2:select');
        //     input.html('');
        //     input.attr('disabled', 'disabled');
        //     input.select2({
        //         placeholder: "Select a data stream...",
        //         minimumResultsForSearch: 10
        //     });
        //     $(".select2-selection.select2-selection--multiple:not(:has(i.fa.fa-search.search-icon-input))").prepend("<i class='fa fa-search search-icon-input'></i>")
        //
        //     input = $('#form_projection');
        //     input.val('');
        //
        //     input = $('#form_references');
        //
        //     input.multiSelect('destroy');
        //     input.html('');
        //     input.multiSelect(searchableMultiSelectDef);
        //     //input.closest('.form_references_container').addClass('hidden');
        //     input.closest('.form_references_container').parent().find('.help-text').removeClass('hidden');
        // }
        //
        // if((step < 3) || (step === 'all')) {
        //     input = $('#form_stations');
        //
        //     input.multiSelect('destroy');
        //     input.html('');
        //     input.multiSelect(searchableMultiSelectDef);
        //     input.closest('.form_dists_container').addClass('hidden');
        //     input.closest('.form_dists_container').parent().find('.help-text').removeClass('hidden');
        // }

        //tvRankerValidate();
    };


    $('.tv-select-demo-container input[type="radio"]').on('change', function () {
        var demo_type = $(this).val();
        var select = $($(this).closest('.tv-select-demo-container').find('select')[0]);
        select.html('');
        select.attr('disabled', null);

        if (demo_type === 'hh') {
            select.append('<option value="hh" selected>-</option>');
            $(this).closest('.tv-select-demo-container').find('.demo_name')
                .val('hh');
            select.attr('readonly', 'readonly');
        } else if (demo_type === '') {
            select.append('<option value="" selected>-</option>');
            select.attr('disabled', 'disabled');
        } else if (demo_type === 'p') {
            demos.each(function (item) {
                var ids = "";
                var string = "";
                $.each(item['blocks']['p'], function (index, value) {
                    ids += value.toString() + ',';
                });

                if(editing==true ){
                    if(r===1) {
                        var dn = edit['primary_demo_name'];
                    }
                    if(r===2)
                        var dn= edit['secondary_demo_name'];

                    select.find('option').prop('selected', null);
                     // select.find('option:contains('+ dn +')').prop('selected', 'selected');

                    $.each( select.find('option'), function (index, value){
                        if($(value).text() == dn)
                            $(value).prop('selected', 'selected');
                    });
                }

                if (item['end'] === null) {
                    string = item['start'] + "+";
                } else {
                    string = item['start'] + "-" + item['end'];
                }

                select.append('<option  value="' + ids + '">' + string + '</option>');
            });
        } else {
            demos.each(function (item) {
                if ((item['start'] !== 6) && (item['start'] !== 2)) {
                    var ids = "";
                    var string = "";
                    $.each(item['blocks'][demo_type], function (index, value) {
                        ids += value.toString() + ',';
                    });

                    if(editing==true ) {
                        if(r==1) {
                            var dn = edit['primary_demo_name'];
                        }
                        if(r==2)
                            var dn= edit['secondary_demo_name'];


                        select.find('option').prop('selected', null);
                        //select.find('option:contains('+ dn +')').prop('selected', 'selected');
                        $.each( select.find('option'), function (index, value){
                            if($(value).text() == dn)
                                $(value).prop('selected', 'selected');
                        });
                    }

                    if (item['end'] === null) {
                        string = item['start'] + "+";
                    } else {
                        string = item['start'] + "-" + item['end'];
                    }

                    select.append('<option  value="' + ids + '">' + string + '</option>');
                }
            });

            if (demo_type === 'f') {
                select.append('<option value="ww">WW</option>');
            }
        }
    });

    $('input[name="primary_demo_type"], input[name="secondary_demo_type"]').on('change', function (e) {
        var demo= $('input:radio[name=' + $(this).attr("name") + ']:checked').val();
        var demo_number = $(this).attr("name");
        var html='';
        if(demo_number == "primary_demo_type")
            $('input[name="primary_demo_name"]').val("");
        else
            $('input[name="secondary_demo_name"]').val("");
        $.each(demo_all, function (index, value) {
            if(value[12].indexOf('Age Range') !== -1){
                if(demo === 'p') {
                    if (value[2].indexOf('A') !== -1) {
                        var ts= value[2].replace('A', "P ");
                        html += '<option title="'+ts+'" value="' + value[0] + '">' + ts + '</option>';
                        if(demo_number == "primary_demo_type") {
                            if ($('input[name="primary_demo_name"]').val() === "")
                                $('input[name="primary_demo_name"]').val(ts);
                        }else {
                            if ($('input[name="secondary_demo_name"]').val() === "")
                                $('input[name="secondary_demo_name"]').val(ts);
                        }
                    }
                }
                if(demo === 'm') {
                    if (value[2].indexOf('M') !== -1) {
                        var ts= value[2].replace('M', "M ");
                        html += '<option title="'+ts+'" value="' + value[0] + '">' + ts + '</option>';
                        if(demo_number == "primary_demo_type") {
                            if ($('input[name="primary_demo_name"]').val() === "")
                                $('input[name="primary_demo_name"]').val(ts);
                        }else {
                            if ($('input[name="secondary_demo_name"]').val() === "")
                                $('input[name="secondary_demo_name"]').val(ts);
                        }
                    }
                }
                if(demo === 'f') {
                    if (value[2].indexOf('W') !== -1) {
                        var ts= value[2].replace('W', "F ");
                        html += '<option title="'+ts+'" value="' + value[0] + '">' + ts + '</option>';
                        if(demo_number == "primary_demo_type") {
                            if ($('input[name="primary_demo_name"]').val() === "")
                                $('input[name="primary_demo_name"]').val(ts);
                        }else {
                            if ($('input[name="secondary_demo_name"]').val() === "")
                                $('input[name="secondary_demo_name"]').val(ts);
                        }
                    }
                }
            }
            if(value[12].indexOf('Household Composition') !== -1 && value[2].indexOf("A25") === -1 && value[2].indexOf("A35") === -1){
                if(demo === 'hh') {
                    if(html == "") {
                        html += '<option value="all">---</option>';
                    }
                    html += '<option title="'+value[2]+'" value="' + value[0] + '">' + value[2] + '</option>';
                    if(demo_number == "primary_demo_type") {
                        if ($('input[name="primary_demo_name"]').val() === "")
                            $('input[name="primary_demo_name"]').val("---");
                    }else {
                        if ($('input[name="secondary_demo_name"]').val() === "")
                            $('input[name="secondary_demo_name"]').val("---");
                    }
                }
            }
        });
        if(demo_number == "primary_demo_type")
            $('#primary_demo_ids').html(html);
        else
            $("#secondary_demo_ids").html(html);
    });
    $('#primary_demo_ids').on('change', function(){
        var x=  $("#primary_demo_ids option:selected");
        $('input[name="primary_demo_name"]').val($(x).text());
    });
    $('#secondary_demo_ids').on('change', function(){
        var x=  $("#secondary_demo_ids option:selected");
        $('input[name="secondary_demo_name"]').val($(x).text());
    });
    $('#income_demo_ids').on('change', function(){
        var x=  $("#income_demo_ids option:selected");
        $('input[name="income_demo_name"]').val($(x).text());
    });
    $('#historic_demo_ids').on('change', function(){
        var x=  $("#historic_demo_ids option:selected");
        $('input[name="historic_demo_name"]').val($(x).text());
    });
    $('#ethnic_demo_ids').on('change', function(){
        var x=  $("#ethnic_demo_ids option:selected");
        $('input[name="ethnic_demo_name"]').val($(x).text());
    });
    $('#education_demo_ids').on('change', function(){
        var x=  $("#education_demo_ids option:selected");
        $('input[name="education_demo_name"]').val($(x).text());
    });
    $('#owner_demo_ids').on('change', function(){
        var x=  $("#owner_demo_ids option:selected");
        $('input[name="owner_demo_name"]').val($(x).text());
    });
    $('#automotive_demo_ids').on('change', function(){
        var x=  $("#automotive_demo_ids option:selected");
        $('input[name="automotive_demo_name"]').val($(x).text());
    });
};
